import Services from "api/ProjectApiConsumer";

export function openTrainingAquatic(obj) {
  return Services.aquaticService.openTrainingAquatic(obj);
}

export function getUsersToTreiningAquatic(obj) {
  return Services.aquaticService.getUsersToTraining(undefined, obj);
}

export function getPhasesAquatic() {
  return Services.aquaticService.getPhasesAquatic();
}
export function updateTask(pathParam, urlParam) {
  return Services.aquaticService.updateTask(undefined, urlParam, pathParam);
}

export function saveAnnotationAquatic(obj) {
  return Services.aquaticService.saveAnnotationAquatic(obj);
}
export function closeTrainingAquatic(id) {
  return Services.aquaticService.closeTrainingAquatic(undefined, undefined, id);
}
export function closeTrainingAquaticBoot(id) {
  return Services.aquaticService.closeTrainingAquaticBoot(undefined, undefined, id);
}


export function doneTrainingAquatic(id) {
  return Services.aquaticService.doneTrainingAquatic(undefined, undefined, id);
}

export function doneTrainingAquaticBoot(id) {
  return Services.aquaticService.doneTrainingAquaticBoot(undefined, undefined, id);
}


export function updateTrainingAquatic(id) {
  return Services.aquaticService.updateTrainingAquatic(
    undefined,
    undefined,
    id
  );
}
export function getMeToTreiningAquatic() {
  return Services.aquaticService.getMeToTreiningAquatic();
}

export function getUsersReviewsAqua(obj) {
  return Services.aquaticService.getUsersReviewsAqua(undefined, obj);
}

export function getUsersToTreiningAquaticBoot(obj) {
  return Services.aquaticService.getUsersToTreiningAquaticBoot(undefined, obj);
}

export function saveTrainingAqua(obj) {
  return Services.aquaticService.saveTrainingAqua(obj);
}

export function getTrainingBoot(id) {
  return Services.aquaticService.getTrainingBoot(undefined, undefined, id);
}
export function getTraining(id) {
  return Services.aquaticService.getTraining(undefined, undefined, id);
}

export function getReviewStats(pathParam) {
  return Services.aquaticService.getReviewStats(undefined, undefined, pathParam);
}